<template>
     <b-modal id="modal-add-template"
                @show="reseTemplateModalValues"
                @hidden="reseTemplateModalValues"
                @ok="handleCreateTemplate"
                size="lg"
                >
            <ValidationObserver ref="observer"
                                tag="form">

                <ValidationProvider tag="div"
                                    vid="templateName"
                                    class="mb-4"
                                    mode="eager"
                                    rules="required"
                                    :customMessages="{required: 'Jāievada šablona nosaukumu'}"
                                    v-slot="{errors}">
                    <label for="templateName" class="d-block text-secondary text-left mb-0">Šablona nosaukums</label>
                    <input type="text" id="templateName" class="w-100 py-1 ds-input" v-model="templateName">
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>
                <ValidationProvider tag="div"
                                    vid="templateSubject"
                                    class="mb-4"
                                    mode="eager"
                                    rules="required"
                                    :customMessages="{required: 'Jāievada e-pasta tematu'}"
                                    v-slot="{errors}">
                    <div class="d-flex justify-content-between align-items-center">
                      <label for="templateSubject" class="d-block text-secondary text-left mb-0">E-pasta temats</label>
                      <b-button :id="'template-header-usage'" size="sm" variant="outline-info">
                        <font-awesome-icon icon="info-circle" />
                      </b-button>
                    </div>
                    <input type="text" id="templateSubject" class="w-100 py-1 ds-input" v-model="templateSubject">
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider tag="div"
                                    vid="templateContent"
                                    class="mb-4"
                                    mode="eager"
                                    rules="required"
                                    :customMessages="{required: 'Jāievada e-pasta tekstu'}"
                                    v-slot="{errors}">
                    <div class="d-flex justify-content-between align-items-center">
                        <label for="templateContent" class="d-block text-secondary text-left mb-0">E-pasta teksts </label>
                        <b-button :id="'template-body-usage'" size="sm" variant="outline-info">
                           <font-awesome-icon icon="info-circle" />
                        </b-button>
                    </div>
                    <b-form-textarea id="templateContent" v-model="templateContent" placeholder="Ievadiet E-pasta šablona tekstu" rows="5"></b-form-textarea>
                    <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                </ValidationProvider>
            </ValidationObserver>
       <b-popover :target="'template-body-usage'"
                  title="Šablona informācija"
                  triggers="hover focus"
                  boundary="viewport"
                  right shadow>
         <div class="px-2 py-1" >
           <h5>Pieejamie mainīgie</h5>
           <code>{user.name}</code> - Lietotāja vārds<br>
           <code>{user.surname}</code> - Lietotāja uzvārds<br>
           <code>{username}</code> - Lietotājvārds<br>
           <code>{company.name}</code> - Uzņēmuma nosaukums<br>
           <code>{ELSA}</code> - Saite uz sistēmu<br>
           <hr>
           <h6>Piemērs:</h6>
           <p class="font-italic small text-muted">
             Sveiki, {user.name}!<br>
             Jūsu uzņēmums {company.name} ir pievienojis jaunu dokumentu.
           </p>
         </div>
       </b-popover>
       <b-popover :target="'template-header-usage'"
                  title="Šablona informācija"
                  triggers="hover focus"
                  boundary="viewport"
                  right shadow>
         <div class="px-2 py-1" >
           <h5>Pieejamie mainīgie</h5>
           <code>{user.name}</code> - Lietotāja vārds<br>
           <code>{user.surname}</code> - Lietotāja uzvārds<br>
           <code>{username}</code> - Lietotājvārds<br>
           <code>{company.name}</code> - Uzņēmuma nosaukums<br>
           <hr>
           <h6>Piemērs:</h6>
           <p class="font-italic small text-muted">
             Paziņojums {company.name} darbiniekiem.
           </p>
         </div>
       </b-popover>
        </b-modal>

</template>
<script>
    import { mapActions } from 'vuex';

    import {ValidationObserver, ValidationProvider, extend} from 'vee-validate';
    import {required} from 'vee-validate/dist/rules';
    import * as templateStoreTypes from '@/vuex/modules/template/template.store-types';


    export default {
        name: 'add-template-modal',
        components: {
            ValidationProvider,
            ValidationObserver,
        },
        data() {
            return {
                templateName: null,
                templateSubject: null,
                templateContent: null
            }
        },
        created() {
            extend('required', required)
        },
        methods: {
            ...mapActions('template', {
                /** @type {function|*} */
                createTemplate: templateStoreTypes.ACTION_CREATE_TEMPLATE,
            }),
            async handleCreateTemplate(bvModal) {
                bvModal.preventDefault()

                const isValid = await this.$refs.observer.validate();
                if (!isValid) {
                    return;
                }
                try {
                    await this.createTemplate({templateName: this.templateName, templateSubject: this.templateSubject, templateContent: this.templateContent})
                    this.resetAddTemplateModal()
                } catch(errors) {
                    this.$refs.observer.setErrors(errors)
                }
            },
            reseTemplateModalValues() {
                this.templateName = null;
                this.templateSubject = null;
                this.templateContent = null;
            },
            resetAddTemplateModal() {
                this.$refs.observer.reset();
                this.reseTemplateModalValues()
                this.$bvModal.hide('modal-add-template')
            }

        }
    }
</script>